import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-simple-input',
  templateUrl: './simple-input.component.html',
  styleUrls: ['./simple-input.component.scss']
})
export class SimpleInputComponent implements OnInit {
  @Input() clearable: boolean;
  @Input() value: string;
  @Input() readonly: boolean;
  @Output() changeValue: EventEmitter<any> = new EventEmitter();
  @Input() placeholder = '';
  public inputValue = '';

  constructor() {}

  ngOnInit() {
    this.inputValue = this.value ? this.value : '';
  }

  /**
   * Recives data from input and set it on inputValue variable
   * @param data value from input
   */
  onKeyUp(data: string): void {
    this.inputValue = data;
    this.changeValue.emit(this.inputValue);
  }

  /**
   * Clean the input value
   */
  clear(): void {
    this.inputValue = '';
  }
}
